// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
[data-theme=light] {
  --widget-frame-background-color: #cdc6cc;
  --widget-frame-text-color: #1e0c1b;
  --widget-frame-button-background: #fff;
  --widget-frame-button-background--hover: #cccccc;
  --widget-frame-button-icon-fill: #291927;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

:root,
[data-theme=dark] {
  --widget-frame-background-color: #493c47;
  --widget-frame-text-color: #f5f3f5;
  --widget-frame-button-background: #1e0c1b;
  --widget-frame-button-background--hover: #4b3d49;
  --widget-frame-button-icon-fill: #f5f3f5;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

.card-image-horizontal {
  position: relative;
}
.card-image-horizontal--square {
  min-height: 60px;
  height: 60px;
  min-width: 60px;
  width: 60px;
}
.card-image-horizontal--square > img {
  border-radius: 3px 0 0 3px;
}
.card-image-horizontal--round {
  min-height: 74px;
  height: 74px;
  min-width: 74px;
  width: 74px;
}
.card-image-horizontal--round > img, .card-image-horizontal--round.card-image-horizontal--empty,
.card-image-horizontal--round .wds-image-placeholder {
  border-radius: 50%;
}
.card-image-horizontal img {
  border: 1px solid var(--widget-border-color--light);
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.card-image-horizontal--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--widget-image-empty-state-color--secondary);
}
.card-image-horizontal--empty .wds-image-placeholder {
  background-color: var(--widget-image-empty-state-color--secondary);
}
.card-image-horizontal--empty svg {
  height: 34px;
  width: 24px;
  max-width: unset;
}
.card-image-horizontal--empty svg path:last-child {
  fill: var(--widget-image-empty-state-color--secondary);
}

:root,
[data-theme=light] {
  --widget-frame-background-color: #cdc6cc;
  --widget-frame-text-color: #1e0c1b;
  --widget-frame-button-background: #fff;
  --widget-frame-button-background--hover: #cccccc;
  --widget-frame-button-icon-fill: #291927;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

:root,
[data-theme=dark] {
  --widget-frame-background-color: #493c47;
  --widget-frame-text-color: #f5f3f5;
  --widget-frame-button-background: #1e0c1b;
  --widget-frame-button-background--hover: #4b3d49;
  --widget-frame-button-icon-fill: #f5f3f5;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

.text-card {
  background-color: var(--widget-primary-background-color);
  border-radius: 0 0 3px 3px;
  display: flex;
  flex-direction: column;
  max-width: 247px;
  min-width: 100px;
  padding: 9px 9px 15px;
  transition: background-color 0.2s ease-in-out;
  width: 100%;
}
.text-card .first-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.text-card .second-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.text-card .third-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.text-card__expanded {
  gap: 6px;
}
.text-card__expanded-wrapper {
  margin-bottom: 6px;
}
.text-card__expanded-content {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.text-card--horizontal {
  border-radius: 0 3px 3px 0;
}
.text-card__metadata {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--widget-text-color--secondary);
  font-size: 12px;
  margin: 3px 0;
  word-break: break-all;
}
.text-card .text-card__title {
  color: var(--widget-link-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  margin: 0;
  transition: all 0.2s ease-in-out;
}
.text-card .text-card__title--link:hover {
  text-decoration: underline;
  color: var(--widget-link-color--hover);
}
.text-card__link {
  text-decoration: none;
}
.text-card__link:focus {
  outline-offset: -1px;
}
.text-card__subtext {
  color: var(--widget-text-color--secondary);
  font-size: 12px;
  line-height: 1.25;
  margin-top: 3px;
}
.text-card__subtext--link {
  display: block;
  text-decoration: none;
}
.text-card__subtext--link:hover {
  text-decoration: underline;
  color: var(--widget-text-color--secondary--hover);
}
.text-card__subtext--link:focus {
  outline-offset: -1px;
}

:root,
[data-theme=light] {
  --widget-frame-background-color: #cdc6cc;
  --widget-frame-text-color: #1e0c1b;
  --widget-frame-button-background: #fff;
  --widget-frame-button-background--hover: #cccccc;
  --widget-frame-button-icon-fill: #291927;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

:root,
[data-theme=dark] {
  --widget-frame-background-color: #493c47;
  --widget-frame-text-color: #f5f3f5;
  --widget-frame-button-background: #1e0c1b;
  --widget-frame-button-background--hover: #4b3d49;
  --widget-frame-button-icon-fill: #f5f3f5;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

:root,
[data-theme=light] {
  --widget-frame-background-color: #cdc6cc;
  --widget-frame-text-color: #1e0c1b;
  --widget-frame-button-background: #fff;
  --widget-frame-button-background--hover: #cccccc;
  --widget-frame-button-icon-fill: #291927;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

:root,
[data-theme=dark] {
  --widget-frame-background-color: #493c47;
  --widget-frame-text-color: #f5f3f5;
  --widget-frame-button-background: #1e0c1b;
  --widget-frame-button-background--hover: #4b3d49;
  --widget-frame-button-icon-fill: #f5f3f5;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

.card-horizontal {
  display: flex;
  position: relative;
}
.card-horizontal--square .text-card {
  padding: 9px 12px;
  justify-content: center;
}
.card-horizontal--round .text-card {
  padding: 9px 12px;
  justify-content: center;
}
.card-horizontal--round .text-card {
  padding-left: 49px;
  margin-left: -37px;
  box-sizing: content-box;
}
.card-horizontal--narrow .text-card {
  padding: 5px 9px;
  justify-content: center;
}
.card-horizontal--narrow .text-card__subtext {
  margin-top: 0;
}
.card-horizontal__image-container {
  position: relative;
}
.card-horizontal__image-container--hoverable:has(+ .text-card .text-card__title--link:hover)::after {
  opacity: 1;
}
.card-horizontal__image-container--hoverable:hover + .text-card .text-card__title--link {
  text-decoration: underline;
  color: var(--widget-link-color--hover);
}
.card-horizontal__image-container--hoverable::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.card-horizontal__image-container--hoverable:hover::after {
  opacity: 1;
}
.card-horizontal__image-container--hoverable-rounded::after {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@fandom-frontend/react-common/dist/components/CardHorizontal.css"],"names":[],"mappings":"AAAA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,sCAAsC;EACtC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,yCAAyC;EACzC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kEAAkE;AACpE;AACA;EACE,kEAAkE;AACpE;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,sDAAsD;AACxD;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,sCAAsC;EACtC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,yCAAyC;EACzC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;EACE,wDAAwD;EACxD,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,iDAAiD;AACnD;AACA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,sCAAsC;EACtC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,yCAAyC;EACzC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,sCAAsC;EACtC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,yCAAyC;EACzC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB","sourcesContent":[":root,\n[data-theme=light] {\n  --widget-frame-background-color: #cdc6cc;\n  --widget-frame-text-color: #1e0c1b;\n  --widget-frame-button-background: #fff;\n  --widget-frame-button-background--hover: #cccccc;\n  --widget-frame-button-icon-fill: #291927;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n:root,\n[data-theme=dark] {\n  --widget-frame-background-color: #493c47;\n  --widget-frame-text-color: #f5f3f5;\n  --widget-frame-button-background: #1e0c1b;\n  --widget-frame-button-background--hover: #4b3d49;\n  --widget-frame-button-icon-fill: #f5f3f5;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n.card-image-horizontal {\n  position: relative;\n}\n.card-image-horizontal--square {\n  min-height: 60px;\n  height: 60px;\n  min-width: 60px;\n  width: 60px;\n}\n.card-image-horizontal--square > img {\n  border-radius: 3px 0 0 3px;\n}\n.card-image-horizontal--round {\n  min-height: 74px;\n  height: 74px;\n  min-width: 74px;\n  width: 74px;\n}\n.card-image-horizontal--round > img, .card-image-horizontal--round.card-image-horizontal--empty,\n.card-image-horizontal--round .wds-image-placeholder {\n  border-radius: 50%;\n}\n.card-image-horizontal img {\n  border: 1px solid var(--widget-border-color--light);\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n.card-image-horizontal--empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--widget-image-empty-state-color--secondary);\n}\n.card-image-horizontal--empty .wds-image-placeholder {\n  background-color: var(--widget-image-empty-state-color--secondary);\n}\n.card-image-horizontal--empty svg {\n  height: 34px;\n  width: 24px;\n  max-width: unset;\n}\n.card-image-horizontal--empty svg path:last-child {\n  fill: var(--widget-image-empty-state-color--secondary);\n}\n\n:root,\n[data-theme=light] {\n  --widget-frame-background-color: #cdc6cc;\n  --widget-frame-text-color: #1e0c1b;\n  --widget-frame-button-background: #fff;\n  --widget-frame-button-background--hover: #cccccc;\n  --widget-frame-button-icon-fill: #291927;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n:root,\n[data-theme=dark] {\n  --widget-frame-background-color: #493c47;\n  --widget-frame-text-color: #f5f3f5;\n  --widget-frame-button-background: #1e0c1b;\n  --widget-frame-button-background--hover: #4b3d49;\n  --widget-frame-button-icon-fill: #f5f3f5;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n.text-card {\n  background-color: var(--widget-primary-background-color);\n  border-radius: 0 0 3px 3px;\n  display: flex;\n  flex-direction: column;\n  max-width: 247px;\n  min-width: 100px;\n  padding: 9px 9px 15px;\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n}\n.text-card .first-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.text-card .second-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.text-card .third-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.text-card__expanded {\n  gap: 6px;\n}\n.text-card__expanded-wrapper {\n  margin-bottom: 6px;\n}\n.text-card__expanded-content {\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.text-card--horizontal {\n  border-radius: 0 3px 3px 0;\n}\n.text-card__metadata {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: var(--widget-text-color--secondary);\n  font-size: 12px;\n  margin: 3px 0;\n  word-break: break-all;\n}\n.text-card .text-card__title {\n  color: var(--widget-link-color);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.25;\n  margin: 0;\n  transition: all 0.2s ease-in-out;\n}\n.text-card .text-card__title--link:hover {\n  text-decoration: underline;\n  color: var(--widget-link-color--hover);\n}\n.text-card__link {\n  text-decoration: none;\n}\n.text-card__link:focus {\n  outline-offset: -1px;\n}\n.text-card__subtext {\n  color: var(--widget-text-color--secondary);\n  font-size: 12px;\n  line-height: 1.25;\n  margin-top: 3px;\n}\n.text-card__subtext--link {\n  display: block;\n  text-decoration: none;\n}\n.text-card__subtext--link:hover {\n  text-decoration: underline;\n  color: var(--widget-text-color--secondary--hover);\n}\n.text-card__subtext--link:focus {\n  outline-offset: -1px;\n}\n\n:root,\n[data-theme=light] {\n  --widget-frame-background-color: #cdc6cc;\n  --widget-frame-text-color: #1e0c1b;\n  --widget-frame-button-background: #fff;\n  --widget-frame-button-background--hover: #cccccc;\n  --widget-frame-button-icon-fill: #291927;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n:root,\n[data-theme=dark] {\n  --widget-frame-background-color: #493c47;\n  --widget-frame-text-color: #f5f3f5;\n  --widget-frame-button-background: #1e0c1b;\n  --widget-frame-button-background--hover: #4b3d49;\n  --widget-frame-button-icon-fill: #f5f3f5;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n:root,\n[data-theme=light] {\n  --widget-frame-background-color: #cdc6cc;\n  --widget-frame-text-color: #1e0c1b;\n  --widget-frame-button-background: #fff;\n  --widget-frame-button-background--hover: #cccccc;\n  --widget-frame-button-icon-fill: #291927;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n:root,\n[data-theme=dark] {\n  --widget-frame-background-color: #493c47;\n  --widget-frame-text-color: #f5f3f5;\n  --widget-frame-button-background: #1e0c1b;\n  --widget-frame-button-background--hover: #4b3d49;\n  --widget-frame-button-icon-fill: #f5f3f5;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n.card-horizontal {\n  display: flex;\n  position: relative;\n}\n.card-horizontal--square .text-card {\n  padding: 9px 12px;\n  justify-content: center;\n}\n.card-horizontal--round .text-card {\n  padding: 9px 12px;\n  justify-content: center;\n}\n.card-horizontal--round .text-card {\n  padding-left: 49px;\n  margin-left: -37px;\n  box-sizing: content-box;\n}\n.card-horizontal--narrow .text-card {\n  padding: 5px 9px;\n  justify-content: center;\n}\n.card-horizontal--narrow .text-card__subtext {\n  margin-top: 0;\n}\n.card-horizontal__image-container {\n  position: relative;\n}\n.card-horizontal__image-container--hoverable:has(+ .text-card .text-card__title--link:hover)::after {\n  opacity: 1;\n}\n.card-horizontal__image-container--hoverable:hover + .text-card .text-card__title--link {\n  text-decoration: underline;\n  color: var(--widget-link-color--hover);\n}\n.card-horizontal__image-container--hoverable::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.15);\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n.card-horizontal__image-container--hoverable:hover::after {\n  opacity: 1;\n}\n.card-horizontal__image-container--hoverable-rounded::after {\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
